export const environment = {
  production: false,
  apiUrl: "/api",
  ssoUrl: "https://login.microsoftonline.com/a1a72d9c-49e6-4f6d-9af6-5aafa1183bfd/oauth2/v2.0",
  clientId: "51213f98-4585-4f54-a09b-eae7c44299a7",
  redirectUrl: "https://test.db-union.dk/api/login/oauth2",
  openIdConfiguration: "https://sso.test.service.deutschebahn.com/f5-oauth2/v1/.well-known/openid-configuration"
};
